/* tslint:disable */
import connectBtnStyles from './connect-button';
import dialogStyles from './dialog';
var css = "\n  ".concat(dialogStyles, "\n  ").concat(connectBtnStyles, "\n");
export default css;